module.exports = __webpack_public_path__ + "img/ic_faq_training.1147677f.svg";